/**
 * Registers an event listener for the 'keydown' event and triggers a callback function when the 'Escape' key is pressed.
 *
 * @param callback A function to be called when the 'Escape' key is pressed.
 * @returns A function that removes the event listener for the 'keydown' event.
 */
export function onEscPress(callback: () => void): () => void {
  const evaluateKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27) {
      callback();
    }
  };

  addEventListener("keydown", evaluateKeyDown);

  return () => {
    removeEventListener("keydown", evaluateKeyDown);
  };
}
